import React, {useState} from 'react';
import {Formik} from "formik";
import Text from "../../Commun/Inputs/Text/Text";
import './login.scss'
import LogoCheckDoc from '../../../assets/logo/checkdoc-blue.png'
import ForgotPasswordContainer from '../ForgotPassword/ForgotPasswordContainer'
import ResetPasswordContainer from '../ResetPassword/ResetPasswordContainer'


const Login = (props) => {
    const { postLogin, loading, isLogin, initialValues, errorState} = props

    // Detect view based on route or URL params
    const getInitialView = () => {
        const path = window.location.pathname
        const urlParams = new URLSearchParams(window.location.search)
        const hasResetToken = urlParams.has('token') && urlParams.has('email')

        if (path === '/forgot-password') {
            return 'forgot-password'
        } else if (path === '/reset-password' || hasResetToken) {
            return 'reset-password'
        }
        return 'login'
    }

    const [view, setView] = useState(getInitialView())

    const switchToForgotPassword = () => {
        setView('forgot-password')
        window.history.pushState({}, '', '/forgot-password')
    }

    const switchToLogin = () => {
        setView('login')
        window.history.pushState({}, '', '/login')
    }

    if (isLogin){
        window.location = '/'
        return null
    }

    return (
        <div id={'login-page'}>
            <div className={"container"}>
                <div className={'row'}>
                    <div className={'bloc-login col-5 text-center'}>
                        <div className={'p-3'}>
                            <img src={LogoCheckDoc} alt="APRIL Moto" className={'img-fluid'} width={120}/>
                            <p className={'pt-3 pb-1'}>Bienvenue sur votre espace<br/>Affaires nouvelles</p>
                        </div>

                        {view === 'login' && (
                            <div className={'p-3 pb-5'}>
                                <Formik initialValues={initialValues} onSubmit={values => postLogin(values)}>
                                    {({handleSubmit, errors, touched, handleChange, handleBlur, values}) => (
                                        <form onSubmit={handleSubmit} className={'row'}>
                                            <div className='col-8 offset-2 mb-4'>
                                                <Text
                                                    type={'text'}
                                                    name="username"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.username}
                                                    required
                                                    label='Identifiant'
                                                    placeholder='Saisissez votre identifiant'
                                                />
                                            </div>
                                            <div className='col-8 offset-2'>
                                                <Text
                                                    type="password"
                                                    name="password"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.password}
                                                    required
                                                    label='Mot de passe'
                                                    placeholder='Saisissez votre mot de passe'
                                                />
                                            </div>
                                            <div className='col-8 offset-2'>
                                                <button type="submit" className={`btn btn-block text-center`} style={{minWidth: 200}}>
                                                    {
                                                        loading ?
                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                                            : <>Je me connecte <span className={'d-inline-block mx-2'}>➜</span></>

                                                    }
                                                </button>
                                            </div>

                                            {errorState && <p className='col-12 error mt-2'>Votre identifiant / mot de passe sont incorrects</p>}

                                            <div className='col-12 mt-3 text-center'>
                                                <a href="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    switchToForgotPassword();
                                                }} style={{fontSize: '14px'}}>
                                                    Mot de passe oublié ?
                                                </a>
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                            </div>
                        )}

                        {view === 'forgot-password' && (
                            <ForgotPasswordContainer onBackToLogin={switchToLogin} />
                        )}

                        {view === 'reset-password' && (
                            <ResetPasswordContainer onBackToLogin={switchToLogin} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
